import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";

@Injectable({
  providedIn: "root",
})
export class ThirdPartySettingsAPIService implements IApiBase {
  configUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }


  getCitronellaImagesSettings() {
    return this.http.get<any>(this.configUrl + `/api/ThirdPartySettings/GetCitronellaImagesSettings`);
  }
}
